import { queryKeys } from "@/lib/query-keys";

/** Playground TanStack keys — canonical definitions live in `@/lib/query-keys.ts`. */
export const playgroundQueryKeys = queryKeys.playground;
